import { render, staticRenderFns } from "./Typo3CreateSubscription.vue?vue&type=template&id=3189f0d4&scoped=true"
import script from "./Typo3CreateSubscription.vue?vue&type=script&lang=js"
export * from "./Typo3CreateSubscription.vue?vue&type=script&lang=js"
import style0 from "./Typo3CreateSubscription.vue?vue&type=style&index=0&id=3189f0d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3189f0d4",
  null
  
)

export default component.exports